import axios from 'axios';
import { errorWrapper } from 'commerce/utils/network';
import { SCAYLE_CDN_URL, VIDEOLYSER_HREF } from 'src/envVariables';
import { MediaApiUrls } from './types';

export const getImgUrl = (hash: string) => {
  if (!hash) {
    console.error('empty hash');
    return '';
  }

  if (hash?.startsWith('http')) {
    return hash;
  }

  if (!SCAYLE_CDN_URL) {
    console.error('SCAYLE_CDN_URL not configured');
  }

  return `${SCAYLE_CDN_URL}/${hash}?quality=100&progressive=1&impolicy=imdb-transparent-background&width=688`;
};

export const getVideolayserEmbededUrl = (url: string) => {
  const id = String(url).match(/(\d+)\.m3u8$/)?.[1] as string;

  if (!VIDEOLYSER_HREF || !id) {
    throw new Error('env variable `VIDEOLYSER_HREF` is missed');
  }

  return VIDEOLYSER_HREF?.replace('VIDEOLYSER_ID', id) || '';
};

export const getYoutubeData = async (youtubeLink: string) => {
  const videoId = new URL(youtubeLink).searchParams.get('v') as string;

  if (!videoId) {
    throw new Error('YouTube videoId is missed');
  }

  return errorWrapper(`Youtube video ${videoId}`, () =>
    axios.get(`${MediaApiUrls.YOUTUBE}&id=${videoId}`),
  );
};
